/*
 * @Author: 陈钊贤
 * @Date: 2019-10-29 11:41:10
 * @LastEditTime: 2021-02-01 10:19:42
 * @LastEditors: 陈钊贤
 * @Description: 请求方法
 * @FilePath: \chen\git-project\test\pilot-oms-operator-front\src\api\require.js
 */
import Vue from "vue";
import axios, { AxiosResponse, AxiosRequestConfig } from "axios";
import common from "../common/common";
import myConfig from "../config/config";
import store from "../store/index";
import { objAny } from "../common/common-interface";
import i18n from "@/config/i18n";
declare type Methods =
  | "GET"
  | "OPTIONS"
  | "HEAD"
  | "POST"
  | "PUT"
  | "DELETE"
  | "TRACE"
  | "CONNECT";
// declare interface Datas {
//   method?: Methods;
//   [key: string]: any;
// }
axios.defaults.timeout = 120000;
axios.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    return config;
  },
  (err: objAny) => {
    return Promise.reject(err);
  }
);
axios.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (err: objAny) => {
    if (err && err.response) {
      return Promise.reject(err.response.data);
    } else {
      err.message = "连接服务器失败!";
      return Promise.reject(err);
    }
  }
);

export const postHeaders = function(data: objAny): objAny {
  const state: any = store.state; // eslint-disable-line
  const loginData: objAny = state.sys.userInfo;
  let headers: objAny = {
    "Content-Type": "application/json;charset=UTF-8",
    "Accept-Language": i18n.locale
  };
  if (loginData && loginData.accessToken) {
    headers["access_token"] = loginData.accessToken;
    headers["Authorization"] = "Bearer " + loginData.accessToken;
  }
  if (data) {
    headers = Object.assign(headers, data);
  }

  return headers;
};

export const request = function(
  url: string,
  params: objAny,
  configData?: objAny
) {
  if (url.indexOf("http") === -1 && url.indexOf(myConfig.ajaxHost) === -1) {
    const ajaxHost: string = myConfig.ajaxHost;
    url = ajaxHost + url;
  }
  const state: any = store.state; // eslint-disable-line
  const loginData: objAny = state.sys.userInfo;

  if (loginData.oprPkId) {
    params.oprPkId = loginData.oprPkId;
  }

  if (loginData.merchantPkId) {
    params.merchantPkId = loginData.merchantPkId;
  }
  let config: objAny | number | string;

  let header: objAny = {};
  let method: AxiosRequestConfig["method"] = "POST";
  if (configData) {
    if (configData.config) {
      config = configData.config;
    }
    if (configData.method === "get") {
      url = url + "?" + common.parseParam(params);
      params = {};
      method = "GET";
    }
    if (configData.method === "del") {
      method = "DELETE";
    }
    if (configData.headers) {
      // headers 合并到请求头里面
      header = configData.headers;
    }
  }
  const headers = postHeaders(header);
  if (!headers) {
    return;
  }

  return new Promise<any>((resolve, reject) => {
    // eslint-disable-line
    const options: AxiosRequestConfig = {
      method: method,
      url: url,
      data: params,
      headers: headers
    };
    axios(options)
      .then(async result => {
        // TODO 逻辑处理

        const successData = result.data;

        if (successData.status === myConfig.apiStatus) {
          resolve(successData);
        } else {
          if (config === "download") {
            if (result.status === 200) {
              resolve(successData);
            } else {
              Vue.prototype.$Notice.error({
                title: i18n.t("tips"),
                desc: successData.msg
              });
            }
          } else {
            Vue.prototype.$Notice.error({
              title: i18n.t("tips"),
              desc: successData.msg
            });
            resolve(successData);
          }
        }
      })
      .catch(async (error: objAny) => {
        if (error.status === 401 || error.status === 4) {
          const text: string =
            error.code == 300022 ? error.msg : i18n.t("header.outTime");
          Vue.prototype.$Modal.confirm({
            title: i18n.t("tips"),
            content: text,
            onOk: () => {
              Vue.prototype.$common.out();
            }
          });
        } else {
          reject(error);
          Vue.prototype.$Modal.error({
            title: i18n.t("tips"),
            content: error.msg
          });
        }
      });
  });
};
